


































































import { IPaymentRequisition, IPaymentRequisitionLine } from '@/models';
import { mapActions, mapGetters } from 'vuex';
import { ErrorManager } from '@/models/error';
import Snackbar from '@/mixins/snackbar';

import PaymentRequisitionDetail from '@/components/payment-requisition/PaymentRequisitionDetail.vue';
import PaymentRequisitionDetailActivityCard from '@/components/payment-requisition/PaymentRequisitionDetailActivityCard.vue';
import PaymentRequisitionStateCard from '@/components/payment-requisition/PaymentRequisitionStateCard.vue';
import PaymentRequisitionDetailDrawer from '@/components/payment-requisition/PaymentRequisitionDetailDrawer.vue';
import PaymentRequisitionLineFormDialog from '@/components/payment-requisition/PaymentRequisitionLineFormDialog.vue';

export default Snackbar.extend({
  components: {
    PaymentRequisitionDetail,
    PaymentRequisitionDetailActivityCard,
    PaymentRequisitionDetailDrawer,
    PaymentRequisitionLineFormDialog,
    PaymentRequisitionStateCard
  },

  data: () => ({
    loading: false,
    errorMessage: '',

    lineItem: null as IPaymentRequisitionLine | null,
    isLineDialogActive: false
  }),

  mounted() {
    // only fetch paymentRequisition if not available in store ("try-get-or-fetch")
    if (!this.paymentRequisition) {
      this.loading = true;
      this.fetchPaymentRequisition(this.paymentRequisitionId)
        .catch(error => {
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => (this.loading = false));
    }
  },

  computed: {
    ...mapGetters({
      getPaymentRequisitionById: 'paymentRequisition/getPaymentRequisitionById'
    }),

    paymentRequisitionId(): number {
      return Number(this.$route.params.id);
    },

    paymentRequisition(): IPaymentRequisition | undefined {
      return this.getPaymentRequisitionById(this.paymentRequisitionId);
    },

    errorOccurred(): boolean {
      return this.errorMessage.length > 0;
    }
  },

  methods: {
    ...mapActions({
      fetchPaymentRequisition: 'paymentRequisition/fetchPaymentRequisition'
    }),

    routeBackToList(action: string) {
      this.$router.replace({ name: 'payment-requisition-list' }).then(() => {
        this.createSnack({
          color: 'success darken-1',
          type: 'success',
          right: true,
          useBtn: false,
          msg: `Payment Requisitions ${action}`,
          btnText: 'Ok',
          timeout: 6000
        });
      });
    },

    openRequisitionDialog(lineItem: IPaymentRequisitionLine) {
      this.lineItem = lineItem;
      this.isLineDialogActive = true;
    }
  }
});
